

import { Component, Vue, Watch, Prop } from "vue-property-decorator"
import { namespace, Getter, Action, State } from "vuex-class"

// @ts-ignore
import VuePerfectScrollbar from "vue-perfect-scrollbar"
import vSelect from "vue-select"

import { CaseDetails, CaseUser, CaseField } from "@/types"

import UserImage from "@/components/UserImage.vue"
import api from "@/services/api"
import { Field } from "@/types/Field"

const caseStore = namespace("cases")

@Component({
	components: {
		"user-image": UserImage,
		"v-select": vSelect,
		"scrollbar": VuePerfectScrollbar
	}
})
export default class CaseUsers extends Vue {
	@Prop()
	public currentCase!: CaseDetails;

	@Prop()
	canEditCurrentCase!: boolean;

	public mounted () {
	}

	public assignUser (user: CaseUser): void {
		if (!this.currentCase || !this.currentCase.id) {
			return
		}

		api.assignUser(this.currentCase.id, user.id)
	}

	private get hasUserRoles (): boolean {
		return this.currentCase && Object.keys(this.currentCase.fields).some(fieldId => this.currentCase.fields[fieldId].field.dataType === "user-role")
	}

	private get userRoleFieldsWithValues (): { field: Field, value: any }[] {
		return Object.keys(this.currentCase.fields)
			.filter(fieldId => this.currentCase.fields[fieldId].field.dataType === "user-role")
			.map(fieldId => {
				return {
					field: this.currentCase.fields[fieldId].field,
					value: this.currentCase.fields[fieldId].value,
					users: this.currentCase.fields[fieldId].value.users
						? this.currentCase.fields[fieldId].value.users.map((u: CaseUser) => this.currentCase.users.find(user => user.id === u.id)).filter((u: CaseUser | undefined) => !!u)
						: [],
					subroles: this.currentCase.fields[fieldId].field.extensions!.hasSubroles
						? this.currentCase.fields[fieldId].field.extensions!.subroles.map((role: any) => {
							return {
								role,
								users: !!this.currentCase.fields[fieldId].value && !!this.currentCase.fields[fieldId].value.subRoles
									? this.currentCase.fields[fieldId].value.subRoles.findAndGet((r: any) => r.title === role.title,
										(r: any) => r.users ? r.users.map((u: CaseUser) => this.currentCase.users.find(user => user.id === u.id)).filter((u: CaseUser | undefined) => !!u) : [],
										[])
									: []
							}
						})
						: []
				}
			})
	}

	// this.currentCase.users.find(user => user.id === r.id)

	private get caseOwner (): any {
		if (!this.currentCase || !this.currentCase.users || !this.currentCase.assigneeId) {
			return null
		}

		return this.currentCase.users.find((f: CaseUser) => f.id === this.currentCase.assigneeId)
	}

	private get caseOthers (): any {
		if (!this.currentCase || !this.currentCase.users) { return [] }

		const caseOwnerId = this.currentCase.assigneeId
		if (caseOwnerId) {
			return this.currentCase.users.filter((f: CaseUser) => f.id !== caseOwnerId)
		} else {
			return this.currentCase.users
		}
	}
}
